import styled from 'styled-components';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
export const Subsection = styled.div`
  background-color: rgba(235, 237, 239, 0.4) !important;
  padding: 10px 0 10px 64px;
  margin: -20px -20px 0 -20px;
`;
export const StyledSpan = styled.span`
  color: #323232;
  font-size: 1.2rem;
  letter-spacing: 0;
  line-height: 1.87rem;
  font-family: 'OpenSans-SemiBold';
`;
export const MainDiv = styled.div`
  height: 750px;
  /* margin: 0px 11px; */
  margin-top: 0px;
  margin-left: -20px;
  margin-right: 48px;
  padding: 0px;
`;
export const StyledAppBar = styled(AppBar)`
  padding-left: 0px;
  margin-left: 0px;
`;
export const StyledTabs = styled(Tabs)`
  margin-left: 49px;
  padding-left: 0px;
  height: 40px !important;
  align-items: flex-end;
  justify-content: center;
`;
export const StyledTab = styled(Tab)`
  && {
    text-transform: none;
    font-size: 14px;
    &.Mui-selected {
      color: #1a98f8;
    }
    font-family: 'OpenSans-Regular';
    padding: 0px;
    font-weight: 500;
    min-height: 40px !important;
  }
`;